export const FILE_EXTENSIONS = Object.freeze({
  XML: 'xml',
  ZIP: 'zip',
  RAR: 'rar',
});
